// extracted by mini-css-extract-plugin
export var brand = "_8k-9";
export var compact = "_8k-6";
export var extraSmall = "_8k-7";
export var icon = "_8k-0";
export var large = "_8k-4";
export var light = "_8k-1";
export var medium = "_8k-5";
export var outline = "_8k-b";
export var primaryDark = "_8k-a";
export var primaryLight = "_8k-8";
export var primaryModern = "_8k-c";
export var success = "_8k-2";
export var successSolid = "_8k-3";